import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Header, Segment, Grid, Image } from "semantic-ui-react";
import { useClient } from "../../hooks/use-client";
import useProducts from "../admin/employees/hooks/useProducts";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmarkLarge } from "@fortawesome/pro-solid-svg-icons";

interface EmployeeAuthFormWrapperProps {
  children: React.ReactNode;
  title: string;
  documentTitle?: string;
  onLogoClick?: () => void;
  adminMode?: boolean;
}

export const EmployeeAuthFormWrapper = ({
  children,
  title,
  documentTitle,
  onLogoClick,
  adminMode = false,
}: EmployeeAuthFormWrapperProps) => {
  const { site } = useParams<{ site: string }>();
  const client = useClient(site);
  const { productsQuery } = useProducts();
  const cityName = useMemo(() => client.query.data?.payload?.data?.attributes?.name, [client.query.data]);

  if (client.query.isLoading || productsQuery.isLoading) return null;

  if (documentTitle) document.title = documentTitle;

  return (
    <Grid verticalAlign='middle' textAlign='center' className='tw-m-0 tw-h-full'>
      <Grid.Column className='tw-max-w-xl tw-text-left'>
        <Grid.Row>
          <Header textAlign='center'>
            <Image
              src='/assets/gogov-logo.svg'
              className='tw-h-[76px] tw-w-72'
              onDoubleClick={onLogoClick}
              alt='GoGov Logo'
            />
          </Header>
          <Header textAlign='center' className='tw-mb-12 tw-mt-2 tw-text-[24px] tw-font-semibold'>
            {cityName}
          </Header>
        </Grid.Row>
        <Segment.Group
          className={classNames({
            "tw-transition-all tw-duration-75": true,
            "tw-border-[3px] tw-border-orange": adminMode,
          })}
        >
          {/* Admin Mode tag */}
          {adminMode && (
            <div className='tw-absolute -tw-top-[1.375rem] tw-left-4 tw-z-10 tw-ml-2 tw-mt-2'>
              <span
                className='tw-rounded-md tw-border-[3px] tw-border-solid tw-border-orange tw-bg-white tw-px-2
                           tw-py-1 tw-text-xs tw-font-semibold tw-tracking-widest tw-text-[#BA4D07]'
              >
                ADMIN MODE
                <button
                  type='button'
                  className='tw-cursor-pointer tw-border-0 tw-bg-transparent tw-pr-0 tw-text-[#BA4D07]'
                  onClick={onLogoClick}
                >
                  <FontAwesomeIcon icon={faXmarkLarge} />
                </button>
              </span>
            </div>
          )}
          <Segment className='tw-p-7'>
            <Header as='h1' textAlign='center' className='tw-mb-6 tw-text-[18px] tw-font-semibold'>
              {title}
            </Header>
            {children}
          </Segment>
        </Segment.Group>
        <Grid.Row className='tw-mt-3 tw-flex tw-items-center tw-justify-between'>
          <div />
          <div className='tw-text-sm tw-text-grey'>Copyright &copy; {new Date().getFullYear()} GOGov</div>
        </Grid.Row>
      </Grid.Column>
    </Grid>
  );
};

export default EmployeeAuthFormWrapper;
